export default {
      id: "icon--share-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "./../Views/Shared/_SvgSprite.cshtml#icon--share",
      toString: function () {
        return this.url;
      }
    }